module.exports="abcweb"


/*****************
 ** WEBPACK FOOTER
 ** ./loaders/module-description-file/~/testloader/lib/loader2.web-loader.js!./loaders/_resources/abc.txt
 ** module id = 1
 ** module chunks = 0
 **/